import React from "react";
import { Card, KeyValueList } from "@sscs/ui";
const CvssDetails = ({ cvss }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, null, "CVSS"),
        React.createElement(Card.Content, null,
            React.createElement(KeyValueList, { list: {
                    "CVSS version": cvss.version,
                    ...Object.fromEntries(cvss.metrics),
                } }))));
};
export default CvssDetails;
//# sourceMappingURL=CvssDetails.js.map